import { defineMessages } from '@/components/formatted_message/FormattedMessage';

export const APP_DICTIONARY = defineMessages({
  // ──────────────────────────────────────────────────────────────────────────
  // Often used
  // ──────────────────────────────────────────────────────────────────────────
  ok: {
    id: 'app.0.dictionary.ok',
  },
  loading: {
    id: 'app.0.dictionary.loading',
  },
  deleting: {
    id: 'app.0.dictionary.deleting',
  },
  noData: {
    id: 'app.0.dictionary.noData',
  },
  locationsAndBuildings: {
    id: 'app.0.dictionary.locationsAndBuildings',
  },
  selectedCount: {
    id: 'app.0.dictionary.selected.count',
  },
  insights: {
    id: 'app.0.dictionary.insights',
  },
  other: {
    id: 'app.0.dictionary.others',
  },
  //
  emptyCell: {
    id: 'app.common.emptyCell',
  },
  notApplicable: {
    id: 'app.common.notApplicable',
  },
  // Inline ICU plural — no separate `.plural` key.
  penalty: {
    id: 'app.0.dictionary.penalty',
  },

  // singular | bare-plural | ICU `*Plural`
  chart: {
    id: 'app.0.dictionary.chart',
  },
  charts: {
    id: 'app.0.dictionary.charts',
  },
  chartPlural: {
    id: 'app.0.dictionary.chart.plural',
  },
  code: {
    id: 'app.0.dictionary.code',
  },
  codes: {
    id: 'app.0.dictionary.codes',
  },
  codePlural: {
    id: 'app.0.dictionary.code.plural',
  },
  dashboard: {
    id: 'app.0.dictionary.dashboard',
  },
  dashboards: {
    id: 'app.0.dictionary.dashboards',
  },
  dashboardPlural: {
    id: 'app.0.dictionary.dashboard.plural',
  },
  overview: {
    id: 'app.0.dictionary.overview',
  },
  overviews: {
    id: 'app.0.dictionary.overviews',
  },
  overviewPlural: {
    id: 'app.0.dictionary.overview.plural',
  },
  map: {
    id: 'app.0.dictionary.map',
  },
  maps: {
    id: 'app.0.dictionary.maps',
  },
  mapPlural: {
    id: 'app.0.dictionary.map.plural',
  },
  detail: {
    id: 'app.0.dictionary.detail',
  },
  details: {
    id: 'app.0.dictionary.details',
  },
  detailPlural: {
    id: 'app.0.dictionary.detail.plural',
  },
  custom: {
    id: 'app.0.dictionary.custom',
  },
  customPlural: {
    id: 'app.0.dictionary.custom.plural',
  },
  setting: {
    id: 'app.0.dictionary.setting',
  },
  settings: {
    id: 'app.0.dictionary.settings',
  },
  settingPlural: {
    id: 'app.0.dictionary.setting.plural',
  },
  carbonFootprint: {
    id: 'app.0.dictionary.carbonFootprint',
  },
  carbonFootprints: {
    id: 'app.0.dictionary.carbonFootprints',
  },
  carbonFootprintPlural: {
    id: 'app.0.dictionary.carbonFootprint.plural',
  },

  // Invoice document subtypes — `.plural` differs from short label (Correction/Regular).
  regularInvoice: {
    id: 'app.0.dictionary.regularInvoice',
  },
  regularInvoices: {
    id: 'app.0.dictionary.regularInvoices',
  },
  regularInvoicePlural: {
    id: 'app.0.dictionary.regularInvoice.plural',
  },
  correctionInvoice: {
    id: 'app.0.dictionary.correctionInvoice',
  },
  correctionInvoices: {
    id: 'app.0.dictionary.correctionInvoices',
  },
  correctionInvoicePlural: {
    id: 'app.0.dictionary.correctionInvoice.plural',
  },

  // ──────────────────────────────────────────────────────────────────────────
  // Entities, collections
  // ──────────────────────────────────────────────────────────────────────────
  customer: {
    id: 'app.0.dictionary.customer',
  },
  customers: {
    id: 'app.0.dictionary.customers',
  },
  customerPlural: {
    id: 'app.0.dictionary.customer.plural',
  },
  user: {
    id: 'app.0.dictionary.user',
  },
  users: {
    id: 'app.0.dictionary.users',
  },
  userPlural: {
    id: 'app.0.dictionary.user.plural',
  },
  establishment: {
    id: 'app.0.dictionary.establishment',
  },
  establishments: {
    id: 'app.0.dictionary.establishments',
  },
  establishmentPlural: {
    id: 'app.0.dictionary.establishment.plural',
  },
  supplyPoint: {
    id: 'app.0.dictionary.supplyPoint',
  },
  supplyPoints: {
    id: 'app.0.dictionary.supplyPoints',
  },
  supplyPointPlural: {
    id: 'app.0.dictionary.supplyPoint.plural',
  },
  meter: {
    id: 'app.0.dictionary.meter',
  },
  meters: {
    id: 'app.0.dictionary.meters',
  },
  meterPlural: {
    id: 'app.0.dictionary.meter.plural',
  },
  invoice: {
    id: 'app.0.dictionary.invoice',
  },
  invoices: {
    id: 'app.0.dictionary.invoices',
  },
  invoicePlural: {
    id: 'app.0.dictionary.invoice.plural',
  },
  leaseUnit: {
    id: 'app.0.dictionary.leaseUnit',
  },
  leaseUnits: {
    id: 'app.0.dictionary.leaseUnits',
  },
  leaseUnitPlural: {
    id: 'app.0.dictionary.leaseUnit.plural',
  },
  manualReading: {
    id: 'app.0.dictionary.manualReading',
  },
  manualReadings: {
    id: 'app.0.dictionary.manualReadings',
  },
  manualReadingPlural: {
    id: 'app.0.dictionary.manualReading.plural',
  },
  remoteReading: {
    id: 'app.0.dictionary.remoteReading',
  },
  remoteReadings: {
    id: 'app.0.dictionary.remoteReadings',
  },
  remoteReadingPlural: {
    id: 'app.0.dictionary.remoteReading.plural',
  },
  notification: {
    id: 'app.0.dictionary.notification',
  },
  notifications: {
    id: 'app.0.dictionary.notifications',
  },
  notificationPlural: {
    id: 'app.0.dictionary.notification.plural',
  },
  tenant: {
    id: 'app.0.dictionary.tenants',
  },
  tenants: {
    id: 'app.0.dictionary.tenants',
  },
  tenantPlural: {
    id: 'app.0.dictionary.tenant.plural',
  },
  time: {
    id: 'app.0.dictionary.time',
  },
  timePlural: {
    id: 'app.0.dictionary.time.plural',
  },
  emissionRecord: {
    id: 'app.0.dictionary.emissionRecord',
  },
  emissionRecords: {
    id: 'app.0.dictionary.emissionRecords',
  },
  emissionRecordPlural: {
    id: 'app.0.dictionary.emissionRecord.plural',
  },

  // ──────────────────────────────────────────────────────────────────────────
  // Properties
  // ──────────────────────────────────────────────────────────────────────────
  name: {
    id: 'app.0.dictionary.name',
  },
  namePlural: {
    id: 'app.0.dictionary.name.plural',
  },
  namePerson: {
    id: 'app.0.dictionary.namePerson',
  },
  namePersonPlural: {
    id: 'app.0.dictionary.namePerson.plural',
  },
  email: {
    id: 'app.0.dictionary.email',
  },
  emailPlural: {
    id: 'app.0.dictionary.email.plural',
  },
  password: {
    id: 'app.0.dictionary.password',
  },
  passwordPlural: {
    id: 'app.0.dictionary.password.plural',
  },
  attachment: {
    id: 'app.0.dictionary.attachment',
  },
  attachments: {
    id: 'app.0.dictionary.attachments',
  },
  attachmentPlural: {
    id: 'app.0.dictionary.attachment.plural',
  },
  businessHours: {
    id: 'app.0.dictionary.businessHours',
  },
  type: {
    id: 'app.0.dictionary.type',
  },
  typePlural: {
    id: 'app.0.dictionary.type.plural',
  },
  flowType: {
    id: 'app.0.dictionary.flowType',
  },
  category: {
    id: 'app.0.dictionary.category',
  },
  unit: {
    id: 'app.0.dictionary.unit',
  },
  unitPlural: {
    id: 'app.0.dictionary.unit.plural',
  },
  date: {
    id: 'app.0.dictionary.date',
  },
  invoiceNumber: {
    id: 'app.0.dictionary.invoiceNumber',
  },
  invoiceNumberPlural: {
    id: 'app.0.dictionary.invoiceNumber.plural',
  },
  invoiceItem: {
    id: 'app.0.dictionary.invoiceItem',
  },
  invoiceItems: {
    id: 'app.0.dictionary.invoiceItems',
  },
  invoiceItemPlural: {
    id: 'app.0.dictionary.invoiceItem.plural',
  },
  tag: {
    id: 'app.0.dictionary.tag',
  },
  tags: {
    id: 'app.0.dictionary.tags',
  },
  tagPlural: {
    id: 'app.0.dictionary.tag.plural',
  },
  register: {
    id: 'app.0.dictionary.register',
  },
  registers: {
    id: 'app.0.dictionary.registers',
  },
  registerPlural: {
    id: 'app.0.dictionary.register.plural',
  },
  establishmentCode: {
    id: 'app.0.dictionary.establishmentCode',
  },
  establishmentCodePlural: {
    id: 'app.0.dictionary.establishmentCode.plural',
  },
  serial: {
    id: 'app.0.dictionary.serial',
  },
  serialPlural: {
    id: 'app.0.dictionary.serial.plural',
  },
  status: {
    id: 'app.0.dictionary.status',
  },
  statusPlural: {
    id: 'app.0.dictionary.status.plural',
  },
  note: {
    id: 'app.0.dictionary.note',
  },
  notePlural: {
    id: 'app.0.dictionary.note.plural',
  },
  billingPeriod: {
    id: 'app.0.dictionary.billingPeriod',
  },
  billingPeriodPlural: {
    id: 'app.0.dictionary.billingPeriod.plural',
  },
  registrationNumber: {
    id: 'app.0.dictionary.registrationNumber',
  },
  registrationNumberPlural: {
    id: 'app.0.dictionary.registrationNumber.plural',
  },
  distribution: {
    id: 'app.0.dictionary.distribution',
  },
  distributionPlural: {
    id: 'app.0.dictionary.distribution.plural',
  },
  supplier: {
    id: 'app.0.dictionary.supplierName',
  },
  supplierPlural: {
    id: 'app.0.dictionary.supplierName.plural',
  },
  owner: {
    id: 'app.0.dictionary.owner',
  },
  newRevision: {
    id: 'app.0.dictionary.newRevision',
  },
  editRevision: {
    id: 'app.0.dictionary.editRevision',
  },
  municipality: {
    id: 'app.0.dictionary.municipality',
  },
  cityDistrict: {
    id: 'app.0.dictionary.cityDistrict',
  },
  street: {
    id: 'app.0.dictionary.street',
  },
  descriptiveNumber: {
    id: 'app.0.dictionary.descriptiveNumber',
  },
  orientationNumber: {
    id: 'app.0.dictionary.orientationNumber',
  },
  district: {
    id: 'app.0.dictionary.district',
  },
  region: {
    id: 'app.0.dictionary.region',
  },
  cadastralArea: {
    id: 'app.0.dictionary.cadastralArea',
  },
  cadastralAreaNumber: {
    id: 'app.0.dictionary.cadastralAreaNumber',
  },
  ownerDeedNumber: {
    id: 'app.0.dictionary.ownerDeedNumber',
  },
  general: {
    id: 'app.0.dictionary.general',
  },
  specific: {
    id: 'app.0.dictionary.specific',
  },
  month: {
    id: 'app.0.dictionary.month',
  },
  powerFactor: {
    id: 'app.0.dictionary.powerFactor',
  },
  powerFactorPlural: {
    id: 'app.0.dictionary.powerFactor.plural',
  },
  distributionRate: {
    id: 'app.0.dictionary.distributionRate',
  },
  distributionRatePlural: {
    id: 'app.0.dictionary.distributionRate.plural',
  },
  contract: {
    id: 'app.0.dictionary.contract',
  },
  contractPlural: {
    id: 'app.0.dictionary.contract.plural',
  },

  electricity: {
    id: 'app.0.dictionary.commodity.Electricity',
  },
  electricityShort: {
    id: 'app.0.dictionary.commodity.Electricity.short',
  },
  gas: {
    id: 'app.0.dictionary.commodity.NaturalGas',
  },
  gasShort: {
    id: 'app.0.dictionary.commodity.NaturalGas.short',
  },
  water: {
    id: 'app.0.dictionary.commodity.Water',
  },
  waterShort: {
    id: 'app.0.dictionary.commodity.Water.short',
  },
  thermal: {
    id: 'app.0.dictionary.commodity.Thermal',
  },
  thermalShort: {
    id: 'app.0.dictionary.commodity.Thermal.short',
  },
  otherCommodity: {
    id: 'app.0.dictionary.commodity.Other',
  },
  otherCommodityShort: {
    id: 'app.0.dictionary.commodity.Other.short',
  },
  pellets: {
    id: 'app.0.dictionary.commodity.PELLETS',
  },
  pelletsShort: {
    id: 'app.0.dictionary.commodity.PELLETS.short',
  },
  meteo: {
    id: 'app.0.dictionary.commodity.METEO',
  },
  meteoShort: {
    id: 'app.0.dictionary.commodity.METEO.short',
  },

  // ──────────────────────────────────────────────────────────────────────────
  // Analysis attributes
  // ──────────────────────────────────────────────────────────────────────────
  analysis: {
    id: 'app.0.dictionary.analysis',
  },
  emissionFactor: {
    id: 'app.0.dictionary.emissionFactor',
  },
  emissionFactors: {
    id: 'app.0.dictionary.emissionFactors',
  },
  emissionFactorPlural: {
    id: 'app.0.dictionary.emissionFactor.plural',
  },
  consumption: {
    id: 'app.0.dictionary.consumption',
  },
  consumptionPlural: {
    id: 'app.0.dictionary.consumption.plural',
  },
  cost: {
    id: 'app.0.dictionary.cost',
  },
  costPlural: {
    id: 'app.0.dictionary.cost.plural',
  },
  price: {
    id: 'app.0.dictionary.price',
  },
  pricePlural: {
    id: 'app.0.dictionary.price.plural',
  },
  value: {
    id: 'app.0.dictionary.value',
  },
  values: {
    id: 'app.0.dictionary.values',
  },
  valuePlural: {
    id: 'app.0.dictionary.value.plural',
  },
  amount: {
    id: 'app.0.dictionary.amount',
  },
  amountPlural: {
    id: 'app.0.dictionary.amount.plural',
  },
  commodity: {
    id: 'app.0.dictionary.commodity',
  },
  commodities: {
    id: 'app.0.dictionary.commodities',
  },
  commodityPlural: {
    id: 'app.0.dictionary.commodity.plural',
  },
  hierarchy: {
    id: 'app.0.dictionary.hierarchy',
  },
  hierarchyPlural: {
    id: 'app.0.dictionary.hierarchy.plural',
  },
  maximum: {
    id: 'app.0.dictionary.maximum',
  },
  maximumPlural: {
    id: 'app.0.dictionary.maximum.plural',
  },
  minimum: {
    id: 'app.0.dictionary.minimum',
  },
  minimumPlural: {
    id: 'app.0.dictionary.minimum.plural',
  },
  average: {
    id: 'app.0.dictionary.average',
  },
  averagePlural: {
    id: 'app.0.dictionary.average.plural',
  },
  quarterhourMax: {
    id: 'app.0.dictionary.quarterhourMax',
  },
  quarterhourMaxPlural: {
    id: 'app.0.dictionary.quarterhourMax.plural',
  },
  unitPrice: {
    id: 'app.0.dictionary.unitPrice',
  },
  unitPricePlural: {
    id: 'app.0.dictionary.unitPrice.plural',
  },
  security: {
    id: 'app.0.dictionary.security',
  },
  total: {
    id: 'app.0.dictionary.total',
  },
  twoFactorAuth: {
    id: 'app.0.dictionary.twoFactorAuth',
  },
  address: {
    id: 'app.0.dictionary.address',
  },
  readingsIntegrity: {
    id: 'app.0.dictionary.readingsIntegrity',
  },
  dataIntegrity: {
    id: 'app.0.dictionary.dataIntegrity',
  },
});
